import { Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import { WarehouseDocumentItemSchema } from '@app/models/wms';

import { WarehouseDocumentKind } from '../../interfaces';

import { ProductLink } from './components/ProductLink';

export const renderValue = (value: string | number | null | undefined) =>
  value === null || value === undefined || value === '' ? '—' : value;

const NAME_COLUMN: ColumnsType<WarehouseDocumentItemSchema>[number] = {
  dataIndex: 'name',
  key: 'name',
  ellipsis: true,
};

const PRICE_COLUMN: ColumnsType<WarehouseDocumentItemSchema>[number] = {
  dataIndex: 'price',
  key: 'price',
  width: 110,
  align: 'right',
  render: renderValue,
};

const QUANTITY_PLAN_COLUMN: ColumnsType<WarehouseDocumentItemSchema>[number] = {
  dataIndex: 'quantity_plan',
  key: 'quantity_plan',
  width: 110,
  align: 'right',
  render: renderValue,
};

const SHIPMENT_QUANTITY_COLUMNS: ColumnsType<WarehouseDocumentItemSchema> = [
  QUANTITY_PLAN_COLUMN,
  {
    dataIndex: 'quantity_picked',
    key: 'quantity_picked',
    width: 110,
    align: 'right',
    render: renderValue,
  },
  {
    dataIndex: 'quantity_shipped',
    key: 'quantity_shipped',
    width: 110,
    align: 'right',
    render: renderValue,
  },
];

const RECEIPT_QUANTITY_COLUMNS: ColumnsType<WarehouseDocumentItemSchema> = [
  QUANTITY_PLAN_COLUMN,
  {
    dataIndex: 'quantity_fact',
    key: 'quantity_fact',
    width: 110,
    align: 'right',
    render: renderValue,
  },
  {
    dataIndex: 'multiplicity',
    key: 'multiplicity',
    width: 110,
    align: 'right',
    render: renderValue,
  },
];

export const getItemColumns = ({ kind }: { kind: WarehouseDocumentKind }): ColumnsType<WarehouseDocumentItemSchema> => [
  {
    ...NAME_COLUMN,
    render: (_: string, record) => {
      if (!record.product_uid) {
        return <Typography.Text ellipsis={{ tooltip: record.name }}>{record.name}</Typography.Text>;
      }

      return <ProductLink name={record.name} productUid={record.product_uid} />;
    },
  },
  ...(kind === 'shipment' ? SHIPMENT_QUANTITY_COLUMNS : RECEIPT_QUANTITY_COLUMNS),
  PRICE_COLUMN,
];
